import { Flex, Text } from '@chakra-ui/react';
import { LoadingButton } from 'modules/common/components/Button/LoadingButton';

import { ButtonCardProps } from './SpreadSheetImport.types';

export const ButtonCard = ({ description, buttonLabel, onClick, isLoading }: ButtonCardProps) => (
  <Flex
    w='100%'
    justify='space-between'
    align='center'
    bg='gray.50'
    border='1px dashed'
    borderColor='gray.300'
    borderRadius='base'
    gap={3}
    p={4}
  >
    <Text fontSize='sm' fontWeight='500'>
      {description}
    </Text>
    <LoadingButton variant='action' size='sm' onClick={onClick} isLoading={isLoading}>
      {buttonLabel}
    </LoadingButton>
  </Flex>
);
